import React, { Component } from 'react'
import { Switch, Route } from 'react-router-dom'
import { ThemeProvider } from 'styled-components'
import {
  Box,
  Button,
  TabBar,
  Layout,
  Header,
  UnifiedTheme,
  Item,
  Avatar,
} from '@revolut/ui-kit'

import { getParameterByName } from 'helpers/common'
import { cdnLink } from 'helpers/cdn'
import { getApplicationDisplayData } from 'helpers/applicationData'
import { PhoneField } from 'components/TextField'
import { LegalFooter } from 'components/LegalFooter'
import { getRetailBaseUrl, getBusinessBaseUrl } from 'helpers/environment'
import type { ApplicationData } from 'services/api'
import { PersonalAccountLink, shouldShowPersonalAccountLink } from './PersonalAccountLink'

export type CredentialsProps = {
  setFieldValue: (field: string, value?: string) => void
  handleSubmit: () => void
  errors: {
    phone: {
      code?: string
      number?: string
    }
  }
  values: {
    phone: {
      code?: string
      number?: string
    }
  }
  applicationData: ApplicationData
}

export class Credentials extends Component<CredentialsProps> {
  render() {
    const { handleSubmit, errors, values, setFieldValue, applicationData } = this.props

    const { authorisationTarget } = getApplicationDisplayData({
      appName: applicationData.name,
      clientId: getParameterByName('client_id'),
    })
    const search = window.location.search
    const retailUrl = `${getRetailBaseUrl()}/open-banking${search}`
    const businessUrl = `${getBusinessBaseUrl()}/oba-consent-confirm${search}`

    return (
      <ThemeProvider theme={UnifiedTheme}>
        <Layout>
          <Layout.Main>
            <Header variant='main'>
              <Header.Title>Sign in to Revolut</Header.Title>
              <Header.Subtitle>{`To authorise ${authorisationTarget}`}</Header.Subtitle>
            </Header>
            <TabBar variant='segmented'>
              <TabBar.Item
                to='/personal'
                // TODO add trigger analytics report  https://revolut.atlassian.net/browse/PAAS-3770
              >
                Personal
              </TabBar.Item>
              <TabBar.Item
                to='/business'
                // TODO add trigger analytics report  https://revolut.atlassian.net/browse/PAAS-3770
              >
                Business
              </TabBar.Item>
            </TabBar>
            <Switch>
              <Route
                path='/personal'
                render={() => (
                  <Box mt='s-16'>
                    {shouldShowPersonalAccountLink() ? (
                      <PersonalAccountLink href={retailUrl} />
                    ) : (
                      <>
                        <PhoneField
                          value={values.phone}
                          onChange={setFieldValue}
                          error={errors.phone}
                        />
                        <Layout.ActionsFill>
                          <Button
                            onClick={() => {
                              // TODO add trigger analytics report  https://revolut.atlassian.net/browse/PAAS-3770
                              handleSubmit()
                            }}
                          >
                            Continue
                          </Button>
                        </Layout.ActionsFill>
                      </>
                    )}
                  </Box>
                )}
              />
              <Route
                path='/business'
                render={() => (
                  <Box mt='s-16'>
                    <Item
                      variant='disclosure'
                      use='a'
                      href={businessUrl}
                      // TODO add trigger analytics report  https://revolut.atlassian.net/browse/PAAS-3770
                    >
                      <Item.Avatar>
                        <Avatar
                          variant='app'
                          image={cdnLink('business/connect/revolut/revolut10_black.png')}
                        />
                      </Item.Avatar>
                      <Item.Content>
                        <Item.Title>Switch to Business account</Item.Title>
                        <Item.Description>Continue in Revolut Business</Item.Description>
                      </Item.Content>
                      <Layout.ActionsFill />
                    </Item>
                  </Box>
                )}
              />
            </Switch>
            <LegalFooter openBankingRegion={applicationData.openBankingRegion} />
          </Layout.Main>
          <Layout.Actions />
        </Layout>
      </ThemeProvider>
    )
  }
}
